import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { StyledCheckbox } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useHookstate } from "@hookstate/core";
import { getFeatureSetOption, getFeaturesList } from "../../../constant";
import {
  FLEET_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
  MAP_GLOBAL_STATES,
  CHECKBOX_LOADER,
  ADS_GLOBAL_STATE,
} from "globalStore/globalStore";

export default function CustomizedCheckbox({
  label,
  identification,
  lockdownText,
  paceEnabled,
  disabled,
  height,
  width,
  activeButtonScheduled,
  activeButtonOff,
}) {
  const [checkboxVal, setCheckboxVal] = useState(false);

  const {
    WeatherAlertGlobal,
    ScorecardGlobal,
    BlindShotGlobal,
    ShowNameSonwelComeScreenGlobal,
    ShowPlaysLikeYardageGlobal,
    HideDistancesGlobal,
    PrintScorecardGlobal,
    ShareScorecardGlobal,
    AutoplayFlyoversGlobal,
    Heatmap,
  } = useHookstate(MAP_GLOBAL_STATES);

  const { redirectState } = useHookstate(ADS_GLOBAL_STATE);

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const {
    enableDisableLockdownState,
    enableDisablePeekChargingState,
    audibleAlertGlobal,
    popUpAlertGlobal,
    ShowOverMaxHolesOnCartGlobal,
    DisableDistancesOnMaxHolesGlobal,
    BehindPaceWarningGlobal,
    PaceStatusTimeGlobal,
  } = useHookstate(FLEET_GLOBAL_STATES);

  const {
    LoadingState,
    generalTabLoader,
    scoreCardTabLoader,
    roundManagementLoader,
    AdminandSupportLoader
  } = useHookstate(CHECKBOX_LOADER);

  const dispatch = useDispatch();

  const {
    siteSettingsData,
    getSiteOffPeakCharginData,
    getScheduledFleetLockdownData,
  } = useSelector((state) => state?.commonReducers) || [];

  useEffect(() => {
    let alertPopupState = JSON.parse(localStorage.getItem("alertPopup"));
    let alertBeepState = JSON.parse(localStorage.getItem("alertBeep"));
    if (alertPopupState !== null && lockdownText === "alertPopup") {
      popUpAlertGlobal.set(alertPopupState);
      setCheckboxVal(alertPopupState);
    } else if (alertBeepState !== null && lockdownText === "alertBeep") {
      setCheckboxVal(alertBeepState);
      audibleAlertGlobal.set(alertBeepState);
    }
  }, []);

  const handleCheckBoxComp = (e) => {
    setCheckboxVal(e.target.checked);
    if (identification) {
      LoadingState.set(true);
      generalTabLoader.set(true);
      scoreCardTabLoader.set(true);

      dispatch(
        COMMON_SERVICES.putFleetSettingsServices(
          {
            code: identification,
            Value:
              lockdownText === "hideDistance"
                ? !e.target.checked
                : e.target.checked,
          },
          siteId.get()
        )
      ).then(() => {
        LoadingState.set(false);
        generalTabLoader.set(false);
        scoreCardTabLoader.set(false);
      });
    } else if (lockdownText === "showOverMaxHoles") {
      roundManagementLoader.set(true);
      dispatch(
        COMMON_SERVICES.putMaxHoleServices(e.target.checked, siteId.get())
      ).then(() => {
        roundManagementLoader.set(false);
      });
      ShowOverMaxHolesOnCartGlobal.set(e.target.checked);
    } else if (lockdownText === "disableDistancesOnMaxHoles") {
      roundManagementLoader.set(true);
      dispatch(
        COMMON_SERVICES.putDisableDistanceServices(
          e.target.checked,
          siteId.get()
        )
      ).then(() => {
        roundManagementLoader.set(false);
      });
      DisableDistancesOnMaxHolesGlobal.set(e.target.checked);
    } else if (lockdownText === "behindPaceWarning") {
      roundManagementLoader.set(true);
      dispatch(
        COMMON_SERVICES.putBehindPaceWarningServices(
          e.target.checked,
          siteId.get()
        )
      ).then(() => {
        roundManagementLoader.set(false);
      });
      BehindPaceWarningGlobal.set(e.target.checked);
    } else if (lockdownText === "powermanagement") {
      AdminandSupportLoader.set(true);
      dispatch(
        COMMON_SERVICES.putFleetSettingsServices({ value: e.target.checked, code: "PM" }, siteId.get())
      ).then(() => {
        AdminandSupportLoader.set(false);
      });
    } else if (lockdownText === "memberantitamper") {
      AdminandSupportLoader.set(true);
      dispatch(
        COMMON_SERVICES.putAllowAntiTamperSelectionServices(e.target.checked, siteId.get())
      ).then(() => {
        AdminandSupportLoader.set(false);
      });
    } else if (lockdownText === "paceStatusTime") {
      roundManagementLoader.set(true);
      dispatch(
        COMMON_SERVICES.putPaceStatusTimeServices(
          e.target.checked,
          siteId.get()
        )
      ).then(() => {
        roundManagementLoader.set(false);
      });
      PaceStatusTimeGlobal.set(e.target.checked);
    } else if (lockdownText === "fleetlockdown") {
      enableDisableLockdownState.set(e.target.checked);
      activeButtonScheduled(true);
      redirectState.set(true);
    } else if (lockdownText === "peekcharging") {
      enableDisablePeekChargingState.set(e.target.checked);
      activeButtonOff(true);
    } else if (lockdownText === "alertBeep") {
      LoadingState.set(true);
      audibleAlertGlobal.set(e.target.checked);
      localStorage.setItem("alertBeep", JSON.stringify(e.target.checked));
    } else if (lockdownText === "alertPopup") {
      LoadingState.set(true);
      popUpAlertGlobal.set(e.target.checked);
      localStorage.setItem("alertPopup", JSON.stringify(e.target.checked));
    } else if (lockdownText === "weatherAlert") {
      WeatherAlertGlobal.set(e.target.checked);
    } else if (lockdownText === "scoreCards") {
      scoreCardTabLoader.set(true);
      ScorecardGlobal.set(e.target.checked);
    } else if (lockdownText === "shareScoreCards") {
      ShareScorecardGlobal.set(e.target.checked);
    } else if (lockdownText === "blindShots") {
      BlindShotGlobal.set(e.target.checked);
    } else if (lockdownText === "Heatmap") {
      Heatmap.set(e.target.checked);
    } else if (lockdownText === "showNames") {
      LoadingState.set(true);
      generalTabLoader.set(true);
      ShowNameSonwelComeScreenGlobal.set(e.target.checked);
    } else if (lockdownText === "playsLikeYardage") {
      LoadingState.set(true);
      generalTabLoader.set(true);
      ShowPlaysLikeYardageGlobal.set(e.target.checked);
    } else if (lockdownText === "hideDistance") {
      HideDistancesGlobal.set(e.target.checked);
    } else if (lockdownText === "printScoreCard") {
      PrintScorecardGlobal.set(e.target.checked);
    } else if (lockdownText === "autoplay") {
      AutoplayFlyoversGlobal.set(e.target.checked);
    } else if (lockdownText === "newMessage") {
      localStorage.setItem("newMessageAudio", e.target.checked);
    } else if (lockdownText === "inboxMessage") {
      localStorage.setItem("inboxMessageAudio", e.target.checked);
    } else if (lockdownText === "popupNewMessage") {
      localStorage.setItem("popupNewMessage", e.target.checked);
    } else {
      return;
    }
  };

  let newMessageAudio =
    localStorage.getItem("newMessageAudio") === "true" ? true : false;

  useEffect(() => {
    if (lockdownText === "newMessage") setCheckboxVal(newMessageAudio);
  }, [newMessageAudio]);

  let inboxMessageAudio =
    localStorage.getItem("inboxMessageAudio") === "true" ? true : false;

  useEffect(() => {
    if (lockdownText === "inboxMessage") setCheckboxVal(inboxMessageAudio);
  }, [inboxMessageAudio]);

  let popupNewMessage =
    localStorage.getItem("popupNewMessage") === "true" ? true : false;

  useEffect(() => {
    if (lockdownText === "popupNewMessage") setCheckboxVal(popupNewMessage);
  }, [popupNewMessage]);

  useEffect(() => {
    if (
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0 &&
      getSiteOffPeakCharginData &&
      Object.keys(getSiteOffPeakCharginData).length > 0
    ) {
      lockdownText === "peekcharging" &&
        !getFeatureSetOption(
          siteSettingsData &&
          siteSettingsData !== null &&
          siteSettingsData?.Features,
          getFeaturesList().real_time_tracking
        ) &&
        setCheckboxVal(getSiteOffPeakCharginData?.IsEnabled);
    }
  }, [siteSettingsData, getSiteOffPeakCharginData]);

  useEffect(() => {
    if (
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0 &&
      getScheduledFleetLockdownData &&
      Object.keys(getScheduledFleetLockdownData).length > 0
    ) {
      lockdownText === "fleetlockdown" &&
        !getFeatureSetOption(
          siteSettingsData &&
          siteSettingsData !== null &&
          siteSettingsData?.Features,
          getFeaturesList().real_time_tracking,
          getFeaturesList().car_control
        ) &&
        setCheckboxVal(enableDisableLockdownState.get());
    }
  }, [
    siteSettingsData,
    enableDisableLockdownState.get(),
  ]);

  useEffect(() => {
    if (siteSettingsData && Object.keys(siteSettingsData).length > 0) {
      lockdownText === "showOverMaxHoles" &&
        setCheckboxVal(siteSettingsData?.MaxHolesExceededAlert);

      lockdownText === "disableDistancesOnMaxHoles" &&
        setCheckboxVal(siteSettingsData.MaxHolesExceededDistancesDisabled);

      lockdownText === "behindPaceWarning" && (!paceEnabled ?
        setCheckboxVal(false) :
        setCheckboxVal(BehindPaceWarningGlobal.get()));

      lockdownText === "paceStatusTime" && (!paceEnabled ?
        setCheckboxVal(false) :
        setCheckboxVal(PaceStatusTimeGlobal.get()));

      lockdownText === "scoreCards" &&
        setCheckboxVal(siteSettingsData?.Scorecard);

      lockdownText === "shareScoreCards" &&
        setCheckboxVal(siteSettingsData?.ShareScorecardEnabled);

      lockdownText === "Heatmap" &&
        setCheckboxVal(siteSettingsData?.GreenViewsEnabled);

      lockdownText === "blindShots" &&
        setCheckboxVal(siteSettingsData?.BlindShots);

      lockdownText === "showNames" &&
        setCheckboxVal(siteSettingsData?.ShowPlayerNamesOnWelcomeScreen);
      lockdownText === "playsLikeYardage" &&
        setCheckboxVal(siteSettingsData?.PlaysLikeYardageEnabled);

      lockdownText === "hideDistance" &&
        setCheckboxVal(!siteSettingsData?.ShowDistances);
      lockdownText === "autoplay" &&
        setCheckboxVal(siteSettingsData?.AutoFlyovers);
      lockdownText === "powermanagement" &&
        setCheckboxVal(siteSettingsData?.PowerManagement);
      lockdownText === "memberantitamper" &&
        setCheckboxVal(siteSettingsData?.MemberAntiTamperEnabled);
    }
  }, [siteSettingsData, paceEnabled]);

  useEffect(() => {
    lockdownText === "alertPopup" && setCheckboxVal(popUpAlertGlobal.get());
    lockdownText === "alertBeep" && setCheckboxVal(audibleAlertGlobal.get());
  }, [popUpAlertGlobal.get(), audibleAlertGlobal.get()]);

  return (
    <StyledCheckbox className="checkbox">
      <FormControlLabel
        control={
          <Checkbox
            checked={checkboxVal}
            onChange={(e) => handleCheckBoxComp(e)}
            inputProps={{ "aria-label": "controlled" }}
            icon={<UnCheckIcon width={width} height={height} />}
            checkedIcon={<CheckIcon width={width} height={height} />}
            disabled={disabled}
          />
        }
        label={label}
      />
    </StyledCheckbox>
  );
}

CustomizedCheckbox.defaultProps = {
  width: "20px",
  height: "20px",
};
